import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@p2p/shared/utils';
import { Observable } from 'rxjs';

import { RatesResponse } from '../entities/rates';

@Injectable({ providedIn: 'root' })
export class RatesDataService {
    private readonly http = inject(HttpClient);

    private readonly url = '/rest/rates';

    getRates(): Observable<RatesResponse> {
        return this.http.get<RatesResponse>(`${environment.apiUrl}${this.url}`);
    }
}
